import React from 'react';
import { NavLink } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { EdgeFinancesLogo } from './EdgeFinancesLogo';

/** Light header for signup, checkout, and other auth flows — no dark mobile drawer. */
export default function AuthNavbar() {
  return (
    <header className="fixed top-0 z-50 w-full border-b border-zinc-200/90 bg-white/95 pt-[env(safe-area-inset-top,0px)] shadow-sm backdrop-blur-md">
      <div className="mx-auto flex h-12 max-w-6xl min-w-0 items-center justify-between gap-2 px-3 sm:h-16 sm:gap-3 sm:px-6">
        <div className="inline-flex min-w-0 max-w-[calc(100%-7.5rem)] items-center overflow-hidden" aria-label="Edge Finance Pro">
          {/* Wordmark hides on very narrow phones so Home / Sign in stay in layout */}
          <EdgeFinancesLogo
            variant="onLight"
            size="sm"
            showWordmark
            className="min-w-0 [&>span]:truncate [&>span]:text-base max-[360px]:[&>span]:hidden"
          />
        </div>
        <div className="flex shrink-0 items-center gap-1 sm:gap-2">
          <NavLink
            to="/"
            className="inline-flex items-center gap-1 rounded-lg px-2 py-1.5 text-xs font-medium text-zinc-600 transition-colors hover:bg-zinc-100 hover:text-zinc-900 sm:gap-1.5 sm:px-3 sm:py-2 sm:text-sm"
          >
            <ArrowLeft className="h-3.5 w-3.5 shrink-0 sm:hidden" aria-hidden />
            <span className="hidden sm:inline">Back to home</span>
            <span className="sm:hidden">Home</span>
          </NavLink>
          <NavLink
            to="/login"
            className="whitespace-nowrap rounded-lg bg-emerald-600 px-2.5 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-emerald-700 sm:px-3 sm:py-2 sm:text-sm"
          >
            Sign in
          </NavLink>
        </div>
      </div>
    </header>
  );
}
